import z from 'zod';
export const SkillSchema = z
    .object({
    id: z
        .number()
        .int('INVALID_ID')
        .min(1, 'INVALID_ID')
        .describe('Integer ID')
        .optional()
        .nullable(),
    name: z.string().min(1, 'REQUIRED_INPUT').max(255).optional()
})
    .describe('Skill object with id and name');
//# sourceMappingURL=skillSchema.js.map